import { Operators } from "../../../../fetch-xml/filter";
import { ICondition } from "./ICondition";

export class MultiSelectOptionSetCondition implements ICondition {
    isValid(record: { value: string | null, formattedValue: string | null }, cond: ComponentFramework.PropertyHelper.DataSetApi.ConditionExpression): boolean {
        const valueStringArray = record.value != null ? record.value.split(",") : [];
        const valueNumberArray = Array.from(valueStringArray, Number);
        const filterNumberArray = Array.from(cond.value, Number);
        const conditionValue = cond.value?.toString().toLowerCase() ?? "";
        const recordValue = record.value?.toLowerCase() ?? "";
        switch (cond.conditionOperator) {
            case Operators.Equal.Value: {
                return recordValue === conditionValue;
            }
            case Operators.DoesNotEqual.Value: {
                return recordValue !== conditionValue;
            }
            case Operators.In.Value: {
                return filterNumberArray.every((x: number) => valueNumberArray.includes(x));
            }
            case Operators.NotIn.Value: {
                return record.value === null || !filterNumberArray.every((x: number) => valueNumberArray.includes(x));
            }
            case Operators.ContainValues.Value: {
                return valueNumberArray.some((x: number) => filterNumberArray.includes(x));
            }
            case Operators.DoesNotContainValues.Value: {
                return record.value === null || !valueNumberArray.some((x: number) => filterNumberArray.includes(x));;
            }
            case Operators.ContainsData.Value: {
                return record.value !== null;
            }
            case Operators.DoesNotContainData.Value: {
                return record.value === null;
            }
        }
        return true;
    }
}
